import instanceService from "./instance";
import {DIRECTORIES_URL, MCS_MIGRATE_URL} from "../helpers/constants";

let instance = instanceService.instance(MCS_MIGRATE_URL)
let indexInstance = instanceService.instance(DIRECTORIES_URL)

export const mcsIntegrationService = {
  getMigrateClients,
  getClientsCount,
  getMigrateDeals,
  getDealsCount,
  getIndexClients,
  getIndexDeals,
}

function getMigrateClients() {
  const options = {
    method: 'GET',
    url: `/clients`
  }
  return instance(options)
}

function getClientsCount() {
  const options = {
    method: 'GET',
    url: `/clients/count`
  }
  return instance(options)
}

function getMigrateDeals() {
  const options = {
    method: 'GET',
    url: `/deals`
  }
  return instance(options)
}

function getDealsCount() {
  const options = {
    method: 'GET',
    url: `/deals/count`
  }
  return instance(options)
}

function getIndexClients() {
  const options = {
    method: 'POST',
    url: `/index/clients`
  }
  return indexInstance(options)
}

function getIndexDeals() {
  const options = {
    method: 'POST',
    url: `/index/deals`
  }
  return indexInstance(options)
}